import type { LocationType } from 'app/types/entities'
import { notifyError, notifySuccess } from 'app/services/notify.client'
import { logError } from 'lib/logging'

// Shared helpers for the PMS workspace wizards. Extracted so the wizard does not re-clone the
// fetch-list and DELETE-remove boilerplate that other integration forms also use.

type LocationStore = { fetchList: () => Promise<{ data?: unknown }>; hits: LocationType[] }

/** Read the workspace location hits from the store, tolerating both response shapes. */
export async function fetchWorkspaceLocationHits(locationStore: LocationStore): Promise<LocationType[]> {
  const result = await locationStore.fetchList()
  const data = result.data as any
  return data?.locations?.hits ?? data?.hits ?? locationStore.hits
}

/** Call the REST DELETE setup endpoint and report the outcome through toasts. */
export async function removeWorkspaceIntegration({
  setupAction,
  name,
  onIntegrationChanged,
  closeModal,
}: {
  setupAction: string
  name: string
  onIntegrationChanged: () => void
  closeModal: () => void
}): Promise<void> {
  try {
    const res = await window
      .fetch(setupAction, {
        method: `DELETE`,
        credentials: `include`,
        headers: { 'Content-Type': `application/json` },
        body: JSON.stringify({}),
      })
      .then((r) => r.json())
    if (res?.success) {
      notifySuccess(`${name} workspace integration removed`)
      onIntegrationChanged()
      closeModal()
    } else {
      notifyError(`Failed to remove: ${res?.message}`)
    }
  } catch (error) {
    logError(`PMS workspace integration remove failed`, error)
    notifyError(`Failed to remove integration: ${error}`)
  }
}
